/** @jsx jsx */

import { Fragment as _ } from 'react';
import { css, jsx } from '@emotion/core';
import { renderToString } from 'react-dom/server';

export const Waves = ({ color = '#66ccff' }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 415 242"
    preserveAspectRatio="xMidYMid slice"
    fill="none"
  >
    <g id="Waves" clipPath="url(#clip0_870_931)">
      <path
        id="Vector"
        d="M0.000823975 242L414.826 242V0L0.000823975 0V242Z"
        fill={color}
      />
      <path
        id="Vector_2"
        opacity="0.2"
        d="M277.834 125.485C231.217 152.414 194.305 140.996 169.409 128.327C137.484 112.082 110.942 85.8709 68.276 81.5821C42.3871 78.9794 18.2457 85.5594 0 92.3042L0 147.745C14.4021 145.077 57.5563 141.382 111.458 176.799C128.602 168.389 151.099 165.156 179.964 174.534C270.742 199.387 278.316 145.324 336.53 134.769C371.284 128.467 403.232 141.826 415 147.644L415 91.6283C399.175 89.3172 346.503 85.818 277.834 125.485Z"
        fill="white"
      >
        <animate
          attributeName="d"
          values="M277.834 125.485C231.217 152.414 194.305 140.996 169.409 128.327C137.484 112.082 110.942 85.8709 68.276 81.5821C42.3871 78.9794 18.2457 85.5594 0 92.3042L0 147.745C14.4021 145.077 57.5563 141.382 111.458 176.799C128.602 168.389 151.099 165.156 179.964 174.534C270.742 199.387 278.316 145.324 336.53 134.769C371.284 128.467 403.232 141.826 415 147.644L415 91.6283C399.175 89.3172 346.503 85.818 277.834 125.485Z;M273.5 110.416C233 134.916 195.895 126.585 171 113.916C139.075 97.671 127.5 65.916 68.5 56.4169C42.6111 53.8142 19 63.416 0 84.7206L0 140.161C14.4021 137.494 57.5563 133.798 111.458 169.215C128.602 160.805 151.099 157.572 179.964 166.95C270.742 191.804 278.316 137.74 336.53 127.185C371.284 120.883 403.232 134.242 415 140.061L415 84.0447C399.175 81.7336 333.783 73.9482 273.5 110.416Z;M277.834 125.485C231.217 152.414 194.305 140.996 169.409 128.327C137.484 112.082 110.942 85.8709 68.276 81.5821C42.3871 78.9794 18.2457 85.5594 0 92.3042L0 147.745C14.4021 145.077 57.5563 141.382 111.458 176.799C128.602 168.389 151.099 165.156 179.964 174.534C270.742 199.387 278.316 145.324 336.53 134.769C371.284 128.467 403.232 141.826 415 147.644L415 91.6283C399.175 89.3172 346.503 85.818 277.834 125.485Z"
          begin="0s"
          dur="8s"
          repeatCount="indefinite"
          fill="freeze"
          calcMode="linear"
          keyTimes="0;0.5;1"
        />
      </path>
      <path
        id="Vector_3"
        opacity="0.35"
        d="M336.411 134.651C278.109 145.202 270.523 199.236 179.609 174.395C150.701 165.022 128.17 168.253 111 176.659C113.28 178.154 115.577 179.713 117.893 181.351C229.663 260.344 267.377 194.765 326.197 188.803C368.996 185.421 403.106 203.849 415 211.327L415 147.52C403.214 141.704 371.218 128.351 336.412 134.651L336.411 134.651Z"
        fill="white"
      >
        <animate
          attributeName="d"
          values="M336.411 134.651C278.109 145.202 270.523 199.236 179.609 174.395C150.701 165.022 128.17 168.253 111 176.659C113.28 178.154 115.577 179.713 117.893 181.351C229.663 260.344 267.377 194.765 326.197 188.803C368.996 185.421 403.106 203.849 415 211.327L415 147.52C403.214 141.704 371.218 128.351 336.412 134.651L336.411 134.651Z;M336.411 127.067C278.109 137.618 270.523 191.652 179.609 166.811C150.701 157.438 128.17 160.669 111 169.075C113.28 170.57 115.577 172.129 117.893 173.767C229.663 252.76 267.377 187.181 326.197 181.219C368.996 177.837 403.106 196.265 415 203.744L415 139.936C403.214 134.12 371.218 120.767 336.412 127.067L336.411 127.067Z;M336.411 134.651C278.109 145.202 270.523 199.236 179.609 174.395C150.701 165.022 128.17 168.253 111 176.659C113.28 178.154 115.577 179.713 117.893 181.351C229.663 260.344 267.377 194.765 326.197 188.803C368.996 185.421 403.106 203.849 415 211.327L415 147.52C403.214 141.704 371.218 128.351 336.412 134.651L336.411 134.651Z"
          begin="0s"
          dur="8s"
          repeatCount="indefinite"
          fill="freeze"
          calcMode="linear"
          keyTimes="0;0.5;1"
        />
      </path>
      <path
        id="Vector_4"
        opacity="0.5"
        d="M326.33 188.87C267.598 194.844 229.942 260.555 118.341 181.403C116.028 179.762 113.734 178.199 111.458 176.702C57.5562 141.232 14.4021 144.933 0 147.605L0 242L415 242L415 211.439C403.124 203.945 369.066 185.48 326.33 188.869L326.33 188.87Z"
        fill="white"
      >
        <animate
          attributeName="d"
          values="M326.33 188.87C267.598 194.844 229.942 260.555 118.341 181.403C116.028 179.762 113.734 178.199 111.458 176.702C57.5562 141.232 14.4021 144.933 0 147.605L0 242L415 242L415 211.439C403.124 203.945 369.066 185.48 326.33 188.869L326.33 188.87Z;M326.33 181.286C267.598 187.26 229.942 252.971 118.341 173.819C116.028 172.178 113.734 170.615 111.458 169.118C57.5562 133.648 14.4021 137.349 0 140.021L0 242L415 242L415 203.855C403.124 196.361 369.066 177.896 326.33 181.285L326.33 181.286Z;M326.33 188.87C267.598 194.844 229.942 260.555 118.341 181.403C116.028 179.762 113.734 178.199 111.458 176.702C57.5562 141.232 14.4021 144.933 0 147.605L0 242L415 242L415 211.439C403.124 203.945 369.066 185.48 326.33 188.869L326.33 188.87Z"
          begin="0s"
          dur="8s"
          repeatCount="indefinite"
          fill="freeze"
          calcMode="linear"
          keyTimes="0;0.5;1"
        />
      </path>
    </g>
    <defs>
      <clipPath id="clip0_870_931">
        <rect width="415" height="242" fill="white" />
      </clipPath>
    </defs>
  </svg>
);

export const wavesSVGToString = color =>
  renderToString(<Waves color={color} />);
